import { render, staticRenderFns } from "./ClientAddressBlock.vue?vue&type=template&id=e4e621e0&"
import script from "./ClientAddressBlock.vue?vue&type=script&lang=js&"
export * from "./ClientAddressBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports